<template>
  <v-card
    class="
      card-section
      query-string-top-panel
      px-md-10
      d-flex
      align-center
      flex-column
      flex-md-row-reverse
      flex-lg-row
      py-4
    "
  >
    <img src="@img/mascot-query-string.svg" alt="query string illustration" width="120">

    <div class="mt-10 mt-md-0 pr-0 pr-md-8 pr-lg-0 pl-lg-8">
      <v-card-title>
        {{ $t('queryString.title') }}
      </v-card-title>

      <p
        v-html="$t('queryString.subtitle')"
        class="
          mt-2
          fs-16
          font-weight-semibold
        "
      />
    </div>
  </v-card>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class QueryStringTopPanel extends Vue {}
</script>

<style lang="scss" scoped>
</style>
